import { render, staticRenderFns } from "./OrderFabricReadyMadeTypeTable.vue?vue&type=template&id=ddb4f34e&scoped=true&"
import script from "./OrderFabricReadyMadeTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricReadyMadeTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb4f34e",
  null
  
)

export default component.exports